module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_6005.90d1c54d.png";